export enum AccountRole {
	ADMIN = "Admin",
	VIEW_ONLY_USER = "ViewOnlyUser",
}

export type Account = {
	HierarchicalUserGroups?: boolean;
	AccountId?: string;
	ShowManufacturingScreen?: boolean;
	AccountName?: string;
	Role: AccountRole;
	UserName: string;
	TimelineSortByOrder?: boolean;
	AccountAlias?: string;
	Billing?: boolean;
	ShipmentStateMachine?: {
		Condition: {
			Status: string;
		};
		Transitions: string[];
		IsInitial: boolean;
		Name: string;
	}[];
	// VodafoneUsage: {};
	isShowEmptyMilestones?: boolean;
	ScanQrTempOnly?: boolean;
	ViewOnlyLink?: string;
	InternalTemperatureSensorName?: string;
	AdditionalInformation?: {
		column: string;
		table: string;
		label: string;
	}[];
	ExternalTemperatureProbeName?: string;
	IncludeAdditionalSensorsToCFR21?: string;
};
